export enum GoalType {
    TimeBased = 'time-based',
    CounterBased = 'counter-based',
    DailyBased = 'daily-based',
  }
  export default GoalType